import { render, staticRenderFns } from "./medal.vue?vue&type=template&id=5993da88&scoped=true&"
import script from "./medal.vue?vue&type=script&lang=js&"
export * from "./medal.vue?vue&type=script&lang=js&"
import style0 from "./medal.vue?vue&type=style&index=0&id=5993da88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5993da88",
  null
  
)

export default component.exports